var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
var ErrorBoundaryContext = createContext(undefined);
function ErrorBoundaryProvider(_a) {
    var error = _a.error, onReset = _a.onReset, children = _a.children;
    return (_jsx(ErrorBoundaryContext.Provider, __assign({ value: { error: error, onReset: onReset } }, { children: children })));
}
function useError() {
    var context = useContext(ErrorBoundaryContext);
    if (context === undefined) {
        throw new Error('Make sure to wrap useError with a ErrorBoundaryProvider or ErrorBoundary component.');
    }
    return context;
}
export { ErrorBoundaryProvider, useError };
